export default __webpack_public_path__ + "static/media/line_four_limbs.79bb6d53.png";